import { restartableTask } from 'ember-concurrency';
import AbstractTransactionsCopier, {
  IAbstractTransactionsCopierArgs,
  WAREHOUSE_ITEM_SEARCH_QUERY
} from 'volta/components/transaction-copier';
import SkuModel from 'volta/models/sku';
import { isDate } from 'volta/utils/date-utils';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface IArgs extends IAbstractTransactionsCopierArgs {}
interface TTransaction {
  incoming: number;
  onHand: number;
  outgoing: number;
  transactionDate: string;
}
export default class TransactionsCopyFromModal extends AbstractTransactionsCopier<IArgs> {
  // Properties
  // ~~~~~

  selectedItemCharts = { incoming: false, outgoing: true, onHand: false };

  // Tracked Properties
  // ~~~~~

  @tracked itemSearchQueryParams = this.args.itemSearchQueryParams ?? WAREHOUSE_ITEM_SEARCH_QUERY;
  @tracked selectedItem?: SkuModel;
  @tracked chartCurrentValues: TTransaction[] | null = [];
  @tracked selectedItemtransactions?: TTransaction[];

  // Getters
  // ~~~~~

  get selectedItems(): SkuModel[] {
    const { selectedItem } = this;

    // wrap the item in an array if present
    return selectedItem ? [selectedItem] : [];
  }

  // Actions
  // ~~~~~

  @action
  selectItem(item: SkuModel) {
    this.bvMetrics.trackAction(this, 'selectItem');
    if (item) {
      this.selectedItem = item;
      this.selectedItemGetTransactions.perform(item.id);
    }
  }
  @action
  clickChart(datum: { x: Date; y: number; position: number }) {
    this.bvMetrics.trackAction(this, 'clickChart');
    const date = datum.x;
    if (date && isDate(datum.x)) {
      this.params = { ...this.params, startDate: date };
    }
  }

  @action
  removeItem() {
    /* unused for now */
    this.bvMetrics.trackAction(this, 'removeItem');
    this.selectedItem = undefined;
  }

  // Tasks
  // ~~~~~

  selectedItemGetTransactions = restartableTask(async (skuId: string) => {
    try {
      const response = await this.store.customQuery('sku', 'transactionsAgg', skuId, undefined);

      if (!response) {
        this.selectedItemtransactions = undefined;
        return;
      }

      this.chartCurrentValues = null;
      if (response && response.length) {
        this.selectedItemtransactions = response.toArray();
      } else {
        this.selectedItemtransactions = undefined;
      }
    } catch (error) {
      defaultErrorHandler(error);
    }
  });
}
